import { 
  // validatePartEstablishment, 
  validateAFM,
  validateYear,
  validatePartPercentage } from 'utils';
import { kadArray } from 'utils/kadArray';

export const carrierShareHoldersFields2 = [
  {
    label: 'Επωνυμία Επιχείρησης',
    type: 'text',
    name: 'partName',
    id: 'partName',
    size: 'large',
    placeholder: 'Επωνυμία Επιχείρησης',
    span: 7,
    asterisk: true,
    rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
  },
  {
    label: 'Α.Φ.Μ.',
    type: 'text',
    name: 'partVat',
    id: 'partVat',
    size: 'large',
    placeholder: 'Εισάγετε Α.Φ.Μ.',
    maxLength: 12,
    span: 3,
    asterisk: true,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      () => ({
        validator(_, value) {
          return validateAFM(value);
        },
      }),
    ],
  },
  {
    label: 'Έτος Ίδρυσης',
    type: 'number',
    name: 'partEstablishment',
    id: 'partEstablishment',
    size: 'large',
    placeholder: 'Εισάγετε Έτος',
    span: 3,
    className: 'shareHolderSelectPartEstablishment',
    maxLength: 4,
    simple: true,
    asterisk: true,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      // () => ({
      //   validator(_, value) {
      //     return validatePartEstablishment(value);
      //   },
      // }),
      () => ({
        validator(_, value) {
          return validateYear(value);
        },
      })
    ],
  },
  {
    title: 'ΚΑΔ Δραστηριότητας',
    label: 'ΚΑΔ Δραστηριότητας',
    type: 'select',
    name: 'partKAD',
    id: 'partKAD',
    showSearch: true,
    className: 'shareHolderSelectKad',
    options: [
      ...kadArray.map(b => ({
        value: b.label + ' - ' + b.value,
      })),
    ],
    size: 'large',
    placeholder: 'Εισάγετε ΚΑΔ Δραστηριότητας',
    maxLength: 12,
    span: 7,
    asterisk: true,
    rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
  },
  {
    label: '% Συμμετοχής',
    type: 'numberWithDecimals',
    name: 'partPercentage',
    id: 'partPercentage',
    size: 'large',
    placeholder: '%',
    decimalsLimit: 15,
    maxLength: 12,
    className: 'partPercentage',
    span: 3,
    asterisk: true,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      () => ({
        validator(_, value) {
          return validatePartPercentage(value);
        },
      }),
    ],
  },
];
